var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c(
        "div",
        { attrs: { id: "backup-summary" } },
        [
          _c("BackupsNavBar", {
            attrs: {
              activeId: _vm.id,
              downloadBtn: true,
              text: "Download Summary Report"
            },
            on: { csv: _vm.downloadCSV }
          }),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "in-out", appear: "" } },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-heading" }, [
                      _vm._v("\n            Backups By Type\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-8" },
                          [
                            _c("BackupSummaryPie", {
                              attrs: {
                                shelvery: _vm.reduceChartData(
                                  _vm.summary.summary,
                                  "shelvery"
                                ),
                                automated: _vm.reduceChartData(
                                  _vm.summary.summary,
                                  "automated"
                                ),
                                manual: _vm.reduceChartData(
                                  _vm.summary.summary,
                                  "manual"
                                ),
                                awsbackup: _vm.reduceChartData(
                                  _vm.summary.summary,
                                  "awsbackup"
                                )
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "total-backups" }, [
                            _c("span", { staticClass: "backup-count" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.reduceChartData(
                                    _vm.summary.summary,
                                    "total"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "backup-count-text" }, [
                              _vm._v("Total Backups")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-heading" }, [
                      _vm._v("\n            Total Backups\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("BackupSummaryTotal", {
                          attrs: {
                            totals: _vm.formatChartData(
                              _vm.summary.summary,
                              "total"
                            )
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-heading" }, [
                      _vm._v(
                        "\n            Backups By Type and Service\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("BackupSummaryBar", {
                          attrs: {
                            shelvery: _vm.formatChartData(
                              _vm.summary.summary,
                              "shelvery"
                            ),
                            automated: _vm.formatChartData(
                              _vm.summary.summary,
                              "automated"
                            ),
                            manual: _vm.formatChartData(
                              _vm.summary.summary,
                              "manual"
                            ),
                            awsbackup: _vm.formatChartData(
                              _vm.summary.summary,
                              "awsbackup"
                            )
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "in-out", appear: "" } },
            [
              _c("div", { key: "third-row", staticClass: "row" }, [
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-heading" }, [
                      _vm._v(
                        "\n            Resources Managed By Shelvery\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("BackupShelveryManagedChart", {
                          attrs: {
                            managed: _vm.formatChartData(
                              _vm.summary.summary,
                              "shelvery_managed"
                            ),
                            notConfigured: _vm.getNotConfigured()
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-heading" }, [
                      _vm._v(
                        "\n            Orphaned Backups By Type and Service\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("BackupSummaryBar", {
                          attrs: {
                            shelvery: _vm.formatChartData(
                              _vm.summary.orphaned,
                              "shelvery"
                            ),
                            automated: _vm.formatChartData(
                              _vm.summary.orphaned,
                              "automated"
                            ),
                            manual: _vm.formatChartData(
                              _vm.summary.orphaned,
                              "manual"
                            ),
                            awsbackup: _vm.formatChartData(
                              _vm.summary.orphaned,
                              "awsbackup"
                            )
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-heading" }, [
                      _vm._v(
                        "\n            Backups By Resource Type and AWS Account\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("BackupsByAccount", {
                          attrs: { data: _vm.summary.summary }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c6e8db2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c6e8db2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Backups.vue
// module id = null
// module chunks = 